$("._toggle-answer").click(function () {
    $(this).parents(".message").toggleClass("_show-answer")
    if(window.innerWidth<=992){
        $(this).parents(".message").find(".message-request").slideToggle()
    }
})
